import {CheckCircleOutline} from '@mui/icons-material';
import {ListItem, ListItemIcon, ListItemText} from '@mui/material';

export interface LandingFeatureItemProps {
  text: string;
}

export default function LandingFeatureItem({text}: LandingFeatureItemProps) {
  return (
    <ListItem>
      <ListItemIcon>
        <CheckCircleOutline color="primary" />
      </ListItemIcon>
      <ListItemText primary={text} />
    </ListItem>
  );
}
